module.exports = __webpack_public_path__ + "static/img/pos_bg.661f665.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/uupay/images/pos_bg.png
// module id = 8VoF
// module chunks = 8